<template>
    <div class="c-baner">
        <img src="@/assets/images/baner_new_02_06_2023.jpg?123" alt="" class="c-baner__image">
    </div>
</template>
<script>
    export default {

    }
</script>
<style lang="scss">
    .c-baner{
        &__image{
            width: 100%;
            max-width: 100vw;
            height: auto;
        }
    }
</style>
